<template>
    <div id="visitors">
        <div class="visitors-sidebar" :class="[dropdown && 'closed']">
            <div class="top">
                <div class="accordion">
                    <div class="head">
                        <div class="title"><span class="material-icons">filter_alt</span> Filter</div>
                    </div>
                    <div class="content" v-if="filteredItems.length > 0">
                        <div class="item" v-for="(filter, index) of filteredItems">
                            <MiniFilterPreview :filter="filter" @deleteFilter="deleteFilter(index)" />
                        </div>
                    </div>
                    <div class="content" v-else>
                        <div class="notting-here">
                            <NoData />
                        </div>
                    </div>
                </div>
            </div>
            <div class="bottom">
                <div class="accordion">
                    <div class="content">
                        <Filters
                            :data="filters"
                            :active="activeFilter"
                            :defaultFilters="filteredItems"
                            @changeActive="(val) => (activeFilter = val)"
                            @filtered="(items) => (filteredItems = items)"
                            align="top"
                            :view-in-side="false"
                        >
                            <template #content>
                                <div class="classic-button">
                                    <span class="material-icons">filter_alt</span>Add Filter
                                </div>
                            </template>
                        </Filters>
                        <div class="classic-button clear-filter" @click="clearFilters">
                            <span class="material-icons">delete</span>Clear
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="visitors-content">
            <div>
                <div class="material-icons" style="cursor: pointer" @click="dropdown = !dropdown">
                    {{ dropdown ? "keyboard_double_arrow_right" : "close" }}
                </div>

                <div class="tool-head">
                    <div class="left-side">
                        <a-input-search
                            style="width: 100%"
                            placeholder="Kullanıcı aramak için birşeyler yazınız."
                            v-model:value="searchText"
                            @search="onSearch"
                            @change="onSearch"
                        ></a-input-search>
                    </div>
                    <div class="right-side">
                        <div style="margin-right: 3px">
                            <b>{{ page }}</b
                            >/<b>{{ Math.ceil(visitorsTotal / perPage) }}</b> of <b>{{ visitorsTotal }}</b> Ziyaretçi
                        </div>
                        <a-button-group style="margin-right: 3px">
                            <a-button class="flex-center-center" @click="backwardPage">
                                <div class="material-icons">arrow_back_ios</div>
                            </a-button>
                            <a-button class="flex-center-center" @click="forwardPage">
                                <div class="material-icons">arrow_forward_ios</div>
                            </a-button>
                        </a-button-group>
                        <a-popover placement="bottomRight" trigger="click">
                            <template slot="content">
                                <div v-for="col of allColumns">
                                    <a-checkbox v-model="col.enabled" @change="onChangeCol(col, $event)">
                                        {{ col.title }}
                                    </a-checkbox>
                                </div>
                            </template>
                            <a-button class="flex-center-center" style="margin-right: 3px">
                                <div class="material-icons">app_registration</div>
                            </a-button>
                        </a-popover>
                        <a-button class="flex-center-center" @click="paddingReset">
                            <div class="material-icons">{{ paddingReseted ? "fullscreen" : "fullscreen_exit" }}</div>
                        </a-button>
                        <a-popover placement="bottomRight" trigger="click">
                            <template slot="content">
                                <div class="export-csv-visitor-page">
                                    <div class="material-icons">description</div>
                                    Export to CSV
                                </div>
                            </template>
                            <a-button class="flex-center-center" style="margin-right: 3px">
                                <div class="material-icons">more_horiz</div>
                            </a-button>
                        </a-popover>
                    </div>
                </div>
                <a-table
                    :class="[paddingReseted && 'padding-zero']"
                    :columns="columns"
                    :data-source="visitors"
                    :pagination="false"
                    :customRow="
                        (record) => {
                            return {
                                on: {
                                    click: (event) => clickRow(record),
                                },
                            };
                        }
                    "
                    :scroll="{ x: 'calc(700px + 50%)' }"
                    :row-class-name="() => 'limited-row'"
                >
                    <div
                        slot="visitingPage"
                        style="
                            max-width: 100%;
                            overflow: hidden;
                            height: 18px;
                            white-space: nowrap;
                            text-transform: ellipsis;
                            text-overflow: ellipsis;
                        "
                        slot-scope="text, record"
                        v-tippy="{ followCursor: true, placement: 'bottom-end' }"
                        :content="text"
                    >
                        {{ text }}
                    </div>
                    <div slot="tags" slot-scope="text, record">
                        <a-tag
                            :color="hashTags[tag] ? hashTags[tag].color : 'orange'"
                            v-for="tag of record.tags"
                            :key="tag"
                        >
                            {{ hashTags[tag] ? hashTags[tag].name : "Bilinmeyen" }}
                        </a-tag>
                    </div>
                    <template
                        v-for="cp of visitorAttributes"
                        :slot="`contactProperty_${cp._id}`"
                        slot-scope="text, record"
                        v-tippy="{ followCursor: true, placement: 'bottom-end' }"
                        :content="(record, text)"
                    >
                        <div>{{ getContactPropertyValue(record, cp._id) }}</div>
                    </template>
                    <template :slot="'firstSeen'" slot-scope="text, record">
                        <div>{{ formatDate(text) }}</div>
                    </template>
                    <template :slot="'lastSeen'" slot-scope="text, record">
                        <div>{{ formatDate(text) }}</div>
                    </template>
                    <template :slot="'connectionTime'" slot-scope="text, record">
                        <div>{{ formatDate(text) }}</div>
                    </template>
                </a-table>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import AppBreadCrumb from "../../../components/common/AppBreadCrumb";
import { log2 } from "../../../utils/log2";
import Filters from "./components/Filters.vue";
import MiniFilterPreview from "./components/MiniFilterPreview.vue";
import moment from "moment";
import NoData from "./components/svg/NoData.vue";

const log = log2("Visitors");

export default {
    name: "Visitors",
    components: {
        AppBreadCrumb,
        Filters,
        MiniFilterPreview,
        NoData,
    },
    data() {
        return {
            dropdown: false,
            filters: [
                {
                    name: this.$t("message.name"),
                    material_icons: "person",
                    multiple: false,
                    key: "fullname",
                    operators: true,
                    inputs: [
                        {
                            key: "fullname",
                            type: "text",
                        },
                    ],
                },
                {
                    name: this.$t("message.email"),
                    material_icons: "alternate_email",
                    multiple: false,
                    key: "email",
                    operators: true,
                    inputs: [
                        {
                            key: "email",
                            type: "text",
                        },
                    ],
                },
                {
                    name: this.$t("chatbotv2.attr.platform"),
                    material_icons: "ads_click",
                    multiple: true,
                    key: "platform",
                    operators: true,
                    inputs: [
                        {
                            type: "select",
                            key: "platform",
                            multiple: true,
                            data: ["web", "mobile", "whatsapp", "instagram", "telegram", "email"].map((key) => ({
                                key,
                                value: key[0].toUpperCase() + key.slice(1),
                            })),
                        },
                    ],
                },
                {
                    name: this.$t("chatbotv2.attr.last_seen"),
                    material_icons: "date_range",
                    multiple: false,
                    key: "lastSeen",
                    inputs: [
                        {
                            name: "Date Between",
                            key: "lastSeen",
                            type: "date",
                        },
                    ],
                },
                {
                    name: this.$t("message.firstSeen"),
                    material_icons: "date_range",
                    multiple: false,
                    key: "firstSeen",
                    inputs: [
                        {
                            name: "Date Between",
                            key: "firstSeen",
                            type: "date",
                        },
                    ],
                },
                {
                    name: this.$t("message.country"),
                    material_icons: "location_on",
                    multiple: false,
                    key: "country",
                    operators: true,
                    inputs: [
                        {
                            key: "country",
                            type: "text",
                        },
                    ],
                },
                {
                    name: this.$t("message.city"),
                    material_icons: "location_on",
                    multiple: false,
                    key: "city",
                    operators: true,
                    inputs: [
                        {
                            key: "city",
                            type: "text",
                        },
                    ],
                },
                {
                    name: this.$t("message.os"),
                    material_icons: "settings_suggest",
                    multiple: false,
                    key: "os",
                    operators: true,
                    inputs: [
                        {
                            key: "os",
                            type: "text",
                        },
                    ],
                },
                {
                    name: this.$t("message.connectionDate"),
                    material_icons: "date_range",
                    multiple: false,
                    key: "connectionTime",
                    inputs: [
                        {
                            name: "Date Between",
                            key: "connectionTime",
                            type: "date",
                        },
                    ],
                },
                {
                    name: this.$t("message.visitingPage"),
                    material_icons: "public",
                    multiple: false,
                    key: "visitingPage",
                    operators: true,
                    inputs: [
                        {
                            key: "visitingPage",
                            type: "text",
                        },
                    ],
                },
                {
                    name: this.$t("message.browser"),
                    material_icons: "computer",
                    multiple: false,
                    key: "browser",
                    operators: true,
                    inputs: [
                        {
                            key: "browser",
                            type: "text",
                        },
                    ],
                },
            ],
            filteredItems: [
                {
                    name: "Contacted",
                    material_icons: "label",
                    multiple: false,
                    notDeleted: true,
                    key: "contacted",
                    inputs: [
                        {
                            type: "select",
                            key: "contacted",
                            multiple: false,
                            value: true,
                            data: [
                                {
                                    key: true,
                                    value: "Yes",
                                },
                                {
                                    key: false,
                                    value: "No",
                                },
                            ],
                        },
                    ],
                },
            ],
            filterAccordion: true,
            activeFilter: false,
            searchText: "",
            visitors: [],
            visitorsTotal: 0,
            staticColumns: [
                {
                    title: this.$t("message.name"),
                    icon: "person",
                    dataIndex: "fullname",
                    key: "fullname",
                    scopedSlots: { customRender: "fullname" },
                },
                {
                    title: this.$t("message.email"),
                    icon: "alternate_email",
                    dataIndex: "email",
                    key: "email",
                    scopedSlots: { customRender: "email" },
                },
                {
                    title: this.$t("chatbotv2.attr.platform"),
                    icon: "ads_click",
                    dataIndex: "platform",
                    key: "platform",
                    scopedSlots: { customRender: "platform" },
                },
                {
                    title: this.$t("chatbotv2.attr.last_seen"),
                    icon: "date_range",
                    dataIndex: "connectionTime",
                    key: "connectionTime",
                    scopedSlots: { customRender: "lastSeen" },
                },
                {
                    title: this.$t("message.firstSeen"),
                    icon: "date_range",
                    dataIndex: "createdAt",
                    key: "createdAt",
                    scopedSlots: { customRender: "firstSeen" },
                },
                {
                    title: this.$t("message.country"),
                    icon: "location_on",
                    dataIndex: "country",
                    key: "country",
                    scopedSlots: { customRender: "country" },
                },
                {
                    title: this.$t("message.city"),
                    icon: "location_on",
                    dataIndex: "city",
                    key: "city",
                    scopedSlots: { customRender: "city" },
                },
                {
                    title: this.$t("message.os"),
                    icon: "settings_suggest",
                    dataIndex: "os",
                    key: "os",
                    scopedSlots: { customRender: "os" },
                },
                {
                    title: this.$t("message.connectionDate"),
                    icon: "date_range",
                    dataIndex: "connectionTime",
                    key: "connectionTime",
                    scopedSlots: { customRender: "connectionTime" },
                },
                {
                    title: this.$t("message.visitingPage"),
                    icon: "public",
                    dataIndex: "visitingPage",
                    key: "visitingPage",
                    scopedSlots: { customRender: "visitingPage" },
                },
                {
                    title: this.$t("message.browser"),
                    icon: "computer",
                    dataIndex: "browser",
                    key: "browser",
                    scopedSlots: { customRender: "browser" },
                },
                {
                    title: "Tags",
                    icon: "ads_click",
                    dataIndex: "tags",
                    key: "tags",
                    scopedSlots: { customRender: "tags" },
                },
            ],
            allColumns: [],
            columns: [],
            page: 1,
            perPage: 10,
            filterTimeout: null,
            paddingReseted: false,
        };
    },
    computed: {
        ...mapGetters({}),
        ...mapState({
            visitorAttributes: (state) => state.contactProperty.data,
            tags: (state) => state.tag.tags.data,
            hashTags: (state) =>
                state.tag.tags.data.reduce((acc, tag) => {
                    acc[tag._id] = tag;
                    return acc;
                }, {}),
            users: (state) => state.user.users.data,
            segments: (state) => state.CB.segments,
        }),
    },
    methods: {
        ...mapActions({
            getVisitorList: "visitor/getVisitorList",
            setVisitorDetailPopup: "app/setVisitorDetailPopup",
        }),
        formatDate(date) {
            return this.$moment(date).format("LLL");
        },
        deleteFilter(index) {
            const f = this.filteredItems.find((filter, i) => i === index);
            if (f.notDeleted) return;
            this.filteredItems = this.filteredItems.filter((filter, i) => i !== index);
        },
        onChangeCol(col, e) {
            if (e.target.checked) {
                this.columns = [...this.columns, col];
            } else {
                this.columns = this.columns.filter((c) => c.dataIndex !== col.dataIndex);
            }
            localStorage.setItem("visitorsColumns", JSON.stringify(this.columns));
        },
        syncColumns() {
            const columnsHash = this.columns.reduce((acc, column) => {
                acc[column.key] = true;
                return acc;
            }, {});

            this.allColumns = [
                ...this.staticColumns.map((col) => ({
                    ...col,
                    enabled: columnsHash[col.key] || false,
                })),
                ...this.visitorAttributes.map((attr) => ({
                    title: attr.label,
                    icon: "tag",
                    dataIndex: `contactProperty_${attr._id}`,
                    key: `contactProperty_${attr._id}`,
                    scopedSlots: { customRender: `contactProperty_${attr._id}` },
                    enabled: columnsHash[`contactProperty_${attr._id}`] || false,
                })),
            ];
        },
        clearFilters() {
            this.filteredItems = this.filteredItems.filter((item) => item.notDeleted);
        },
        syncFilters() {
            const filters = this.$route.query.filters;
            if (filters) {
                try {
                    this.filteredItems = JSON.parse(filters);
                } catch {
                    this.filteredItems = [];
                }
            }
            const findPropertyFilter = this.filters.findIndex((f) => f.key === "contact_properties");
            const propertyFilter = {
                name: "Contact Properties",
                material_icons: "alternate_email",
                multiple: true,
                key: "contact_properties",
                operators: true,
                inputs: [
                    {
                        type: "select",
                        key: "contact_property",
                        multiple: false,
                        data: this.visitorAttributes.map((attr) => ({
                            key: attr._id,
                            value: attr.label,
                        })),
                    },
                    {
                        name: "Search",
                        key: "search",
                        type: "text",
                    },
                ],
            };
            if (findPropertyFilter < 0) {
                this.filters = [...this.filters, propertyFilter];
            } else {
                this.filters.splice(findPropertyFilter, 1, propertyFilter);
            }

            const findTagFilter = this.filters.findIndex((f) => f.key === "tags");
            const tagFilter = {
                name: "Tags",
                material_icons: "label",
                multiple: true,
                key: "tags",
                operators: true,
                disableOperators: ["starts_with", "ends_with"],
                inputs: [
                    {
                        type: "select",
                        key: "tags",
                        multiple: true,
                        data: this.tags.map((tag) => ({
                            key: tag._id,
                            value: tag.name,
                        })),
                    },
                ],
            };
            if (findTagFilter < 0) {
                this.filters = [...this.filters, tagFilter];
            } else {
                this.filters.splice(findTagFilter, 1, tagFilter);
            }

            const fUserFilter = this.filters.findIndex((f) => f.key === "agent_filter");
            const userFilter = {
                name: "Prefered Agents",
                material_icons: "support_agent",
                multiple: true,
                key: "agent_filter",
                operators: true,
                disableOperators: ["starts_with", "ends_with"],
                inputs: [
                    {
                        type: "select",
                        key: "agent",
                        multiple: true,
                        data: this.users.map((user) => ({
                            key: user._id,
                            value: user.name,
                        })),
                    },
                ],
            };
            if (fUserFilter < 0) {
                this.filters = [...this.filters, userFilter];
            } else {
                this.filters.splice(fUserFilter, 1, userFilter);
            }

            const fSegmentFilter = this.filters.findIndex((f) => f.key === "segment_filter");
            const segmentFilter = {
                name: "Segments",
                material_icons: "groups",
                multiple: true,
                key: "segment_filter",
                operators: true,
                disableOperators: ["starts_with", "ends_with"],
                inputs: [
                    {
                        type: "select",
                        key: "segment",
                        multiple: true,
                        data: this.segments.map((user) => ({
                            key: user._id,
                            value: user.name,
                        })),
                    },
                ],
            };
            if (fSegmentFilter < 0) {
                this.filters = [...this.filters, segmentFilter];
            } else {
                this.filters.splice(fSegmentFilter, 1, segmentFilter);
            }
        },
        forwardPage() {
            if (Math.ceil(this.visitorsTotal / this.perPage) <= this.page) return;
            this.page = this.page + 1;
            this.getVisitors();
        },
        backwardPage() {
            if (this.page === 1) return;
            this.page = this.page - 1;
            this.getVisitors();
        },
        getContactPropertyValue(visitor, cpId) {
            return visitor.contactproperties?.find((c) => c.property === cpId)?.value || "N/A";
        },
        paddingReset() {
            this.paddingReseted = !this.paddingReseted;
        },
        onSearch() {
            this.page = 1;
            this.getVisitors();
        },
        getVisitors() {
            localStorage.setItem(
                "visitorFilters",
                JSON.stringify({
                    filters: this.filteredItems,
                    page: this.page,
                    pageSize: this.perPage,
                    query: this.searchText,
                })
            );
            this.getVisitorList({
                filters: this.getFilters(),
                page: this.page,
                pageSize: this.perPage,
                query: this.searchText,
            }).then((response) => {
                this.visitorsTotal = response.data.total;
                this.visitors = response.data.data;
            });
        },
        formatDayJSToMoment(dayjs) {
            return moment(dayjs._d.toString());
        },
        getFilters() {
            return this.filteredItems
                .map((filter) =>
                    filter.inputs.reduce((acc, input, index) => {
                        if (
                            input.type === "date" && input.period !== "custom"
                                ? !input.period
                                : input.value === "" || input.value === null || input.value === undefined
                        )
                            return;
                        if (index === 0) {
                            acc = {
                                key: input.key,
                                rule: filter.rule,
                                input: input.period ? (input.period === "custom" ? input.value : null) : input.value,
                                period: input.period,
                            };
                        } else if (index >= 1) {
                            acc[input.key] = input.value;
                        }
                        return acc;
                    }, {})
                )
                .filter((c) => c);
        },
        clickRow(record) {
            this.setVisitorDetailPopup(record._id);
        },
    },
    async mounted() {
        this.columns = JSON.parse(
            localStorage.getItem("visitorsColumns") || JSON.stringify(this.staticColumns.slice(0, 5))
        );
        const filters = JSON.parse(localStorage.getItem("visitorFilters") || "{}");
        this.filteredItems = filters.filters || this.filteredItems;
        this.perPage = filters.pageSize || this.perPage;
        this.page = (filters.page !== null && filters.page !== undefined && filters.page) || 1;
        this.searchText = filters.query;
        this.syncFilters();
        this.syncColumns();
        this.getVisitors();
    },
    watch: {
        visitorAttributes: {
            handler() {
                this.syncColumns();
                this.syncFilters();
            },
            deep: true,
        },
        tags: {
            handler() {
                this.syncFilters();
            },
            deep: true,
        },
        users: {
            handler() {
                this.syncFilters();
            },
            deep: true,
        },
        searchText: {
            handler() {
                this.syncFilters();
            },
            deep: true,
        },
        segments: {
            handler() {
                this.syncFilters();
            },
            deep: true,
        },
        filteredItems: {
            handler(val) {
                localStorage.setItem(
                    "visitorFilters",
                    JSON.stringify({
                        filters: this.filteredItems,
                        page: this.page,
                        pageSize: this.perPage,
                        query: this.searchText,
                    })
                );
                if (this.filterTimeout) clearTimeout(this.filterTimeout);
                this.filterTimeout = setTimeout(() => this.getVisitors(), 500);
                this.page = 1;
            },
            deep: true,
        },
    },
};
</script>

<style lang="scss">
.export-csv-visitor-page {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.notting-here {
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
        width: 200px;
    }
}

#visitors {
    position: relative;
    background-color: white;
    height: 100%;
    display: flex;

    .flex-center-center {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .padding-zero {
        th,
        td {
            padding: 0;
        }
    }

    .limited-row td {
        min-height: 50px;
        height: 50px;
        max-width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-transform: ellipsis;
        text-overflow: ellipsis;
    }

    .visitors-sidebar {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        flex-direction: column;
        min-width: 280px;
        border-right: 1px solid #dddddd;
        transition: all 0.5s;

        &.closed {
            margin-left: -280px;
        }

        .top,
        .bottom {
            width: 100%;
        }

        .top {
            :nth-child(1).accordion {
                border: none;
            }
        }

        .accordion {
            border-top: 1px solid #dddddd;
            width: 100%;

            .head {
                padding: 10px 10px 0px 10px;
                font-weight: bold;
                display: flex;
                align-items: center;
                justify-content: space-between;
                user-select: none;
                cursor: pointer;

                .title {
                    display: flex;
                    align-items: center;
                    font-size: 18px;

                    span.material-icons {
                        margin-right: 5px;
                    }
                }
            }

            .content {
                width: 100%;
                padding: 10px;
                height: 100%;

                :first-child.item {
                    margin-top: 0px;
                }

                .item {
                    .title {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        border-radius: 4px;
                        margin-top: 7px;
                        cursor: pointer;
                    }

                    .text {
                        display: flex;
                        align-items: center;
                        font-size: 15px;
                        font-weight: bold;

                        .material-icons {
                            font-size: 14px;
                            margin-right: 5px;
                        }
                    }

                    .score {
                        overflow: hidden;
                        border: 1px solid #dddddd;
                        padding: 0px 10px;
                        font-size: 10px;
                        font-weight: bold;
                    }
                }
            }
        }

        .bottom {
            .accordion .content {
                display: flex;
                justify-content: space-between;
                align-items: center;

                &:nth-child(1) {
                    margin-right: 5px;
                }

                &:nth-child(2) {
                    margin-left: 5px;
                }
            }
        }
    }

    .visitors-content {
        width: 100%;
        padding: 30px;

        .tool-head {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 20px;
            margin-bottom: 20px;

            .left-side {
                width: 50%;
            }

            .right-side {
                display: flex;
                align-items: center;
            }
        }

        .filter-name {
            display: flex;
            align-items: center;
            font-weight: bold;
            font-size: 18px;

            &.active {
                span.material-icons {
                    color: goldenrod;
                }
            }

            span.material-icons {
                margin-left: 5px;
            }
        }
    }

    .classic-button {
        border: 1px solid #dddddd;
        padding: 4px 10px;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;

        span {
            margin-right: 5px;
            font-size: 16px;
        }

        &.clear-filter {
            margin-left: 3px;
        }
    }
}
</style>
